























































import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import multipleDataEchart from '../../../components/charts/multipleDataEchart.vue'
import Util from '../../../lib/util'
import {MachieRepair,GetUsers} from '../../../api/dialysisProcess'
import util from "../../../lib/util";
import uploadImg from '../../../components/upload/dialysisBeginUploadImg.vue'

@Component({
     components:{uploadImg}
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    
    //表单值
    roleRule = {
        date:[{required: true,message:this.L('FieldIsRequired'),type:'date',trigger: 'blur'}],
        repairUserId:[{required:true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        content:[{required:false,message:this.L('FieldIsRequired'),trigger: 'blur'}],
    }
    form:any = {
        patientId:this.data.patientId,
        date:new Date(),
        repairUserId:null,
        content:null,
        imagePath:null,
    }
    piclist:any = {}
    created() {
        // this.getPatBeforeDryWeightData()
        this.getUsers()
    }
    repairUserOptions:any = []
    async getUsers(){
        let res = await GetUsers({})
        this.repairUserOptions = res.objects
    }
    picConfirm(list:any){
        let paths = list.map((item:any)=>{
            return item.path
        })
        this.form.imagePath = paths.join(',')
    }
    save(){
        (this.$refs.roleForm as any).validate(async (valid:boolean)=>{
            if(valid){
                console.log(this.data)
                this.saveBDialyWeight(this.form)
            }
        })
    }
    async saveBDialyWeight(data:any){
        let res = await MachieRepair(data)
        if(res.status == 1){
            // this.$Message.success('保存成功')
            this.$emit('input',false);
            this.$emit('on-success')
        }else{
            // this.$Message.error(res.message)
        }
    }

    mounted() {
       
    }
    cancel(){
        // (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/machieRepair.vue